import { Icon } from '@festina-life/ui/structure'
import cx from 'classnames'
import type { ReactNode } from 'react'

type HoverPopoverItemProps = {
  label: ReactNode | null
  isActive: boolean
  onFocus: () => void
  onBlur: () => void
  onMouseEnter: () => void
  labelClassName?: string
}

export const HoverMenuItem = ({
  label,
  isActive,
  onBlur,
  onFocus,
  onMouseEnter,
  labelClassName,
}: HoverPopoverItemProps) => (
  <div
    onMouseEnter={onMouseEnter}
    onFocus={onFocus}
    onBlur={onBlur}
    className={cx(
      'flex w-full cursor-pointer p-2 selected:border-hidden hover:bg-primary-100 dark:hover:bg-primary-700 rounded-md',
      isActive ? 'bg-primary-100 dark:bg-primary-700 rounded-md' : '',
      labelClassName,
    )}
  >
    <div className="w-full text-sm">{label}</div>
    <Icon name="ChevronRight" size="md" />
  </div>
)
